module.exports = __webpack_public_path__ + "static/media/truck-delivery.b39d0ca4.png";